/**
 * removeEmptyKeys iterates through passed object, removes any keys that are empty, and returns the same object with
 * empty keys removed.
 * @param {object} objectWithEmptyKeys the object containing empty keys
 * @returns {object} the object with empty keys removed
 */
export const removeEmptyKeys = (object) => {
  Object.entries(object).forEach(
    ([key, value]) =>
      (value && typeof value === "object" && removeEmptyKeys(value)) ||
      ((!value || (typeof value === "string" && value?.trim() === "")) && delete object[key])
  );

  return object;
};
